<div 
  *ngIf="getVisibleContent()"
  tuiDropdownAlign="right"
  [tuiDropdown]="menuTmp"
  [(tuiDropdownOpen)]="open"
  (click)="$event.stopPropagation()"
>
  <ng-content></ng-content>
</div>

<ng-template #menuTmp>
  <view-data-list [items]="items" [object]="object" (clicked)="itemClicked()"></view-data-list>
</ng-template>
